import { uploadOneFile, deleteOneFile } from "../common/DownloadUploadFilesHelper";
import mergeDeep from "../../util/mergeDeep.js";
import * as domainConstants from "../../constants/DomainConstants";
import showToastr, { showToastrInfo, showToastrError, showToastrSuccess } from "../../util/toastr.js";
import { getStore } from "../../store/configureStore";
import GenerateGuid from "../../util/guid";

export default class MinimaleEisenPerDossierPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	update(nextProps) {
		if (this.context.props.minimaleEisenPerDossier !== nextProps.minimaleEisenPerDossier) {
			const minimaleEisenPerDossier = nextProps.minimaleEisenPerDossier;
			if (minimaleEisenPerDossier.tabTitel) {
				this.context.props.loadLayout(minimaleEisenPerDossier.naam, minimaleEisenPerDossier.tabTitel, nextProps.dossierId, minimaleEisenPerDossier.typeDossier, nextProps.infrastructuurId, (minimaleEisenPerDossier.redenVanStatus != "121450000" && minimaleEisenPerDossier.redenVanStatus !== 121450000));
			}
			this.context.setState({
				minimaleEisenPerDossier: mergeDeep({}, minimaleEisenPerDossier),
				titleSet: minimaleEisenPerDossier.tabTitel,
				errors: nextProps.errors
			});
		}
	}

	init() {
		const dossierId = this.context.props.dossierId;

		if (dossierId) {
			this.context.props.getContent(this.context.props.dossierId, domainConstants.DocumentTab.MinimaleEisen)
				.then(result => {
					if (result.success) {
						this.context.setState(
							{
								documenten: result.data
							});
					} else {
						showToastrError("Laden van het dossier is mislukt");
						throw new Error("getContent load failed"); //Stops promise
					}
				});
		}
		this.context.props.getSjablonen(domainConstants.DocumentTab.MinimaleEisen)
			.then(result => {
				if (result.success) {
					this.context.setState(
						{
							sjablonen: result.data
						});
				} else {
					showToastrError("Laden van de sjablonen is mislukt");
					throw new Error("getSjablonen load failed"); //Stops promise
				}
			});

		this.context.props.loadInfrastructurenByDossierId(dossierId);
		this.context.props.loadMinimaleEisenPerDossier(dossierId);
	}

	onChange(event, data) {
		const field = event.target.name;
		const minimaleEisen = this.context.state.minimaleEisenPerDossier;
		minimaleEisen[field] = event.target.value;

		if (field === "werkenTijdigGestart" && minimaleEisen[field].toString() === "false")
			minimaleEisen.welkeWerkenGestart = null;

		if (field === "prioritairVoorVlaamseTopsportfederaties" && minimaleEisen[field].toString() === "false")
			minimaleEisen.prioritairGebruikTopsportfederaties = [];

		return this.context.setState({
			minimaleEisenPerDossier: minimaleEisen,
			hasUnsavedChanges: true
		});
	}

	onTopsportfederatieChange(event, i) {
		const minimaleEisen = this.context.state.minimaleEisenPerDossier;
		minimaleEisen.prioritairGebruikTopsportfederaties[i][event.target.name] = event.target.value;
		return this.context.setState({
			minimaleEisenPerDossier: minimaleEisen,
			hasUnsavedChanges: true
		});
	}

	onTopsportfederatieAdd() {
		const minimaleEisen = this.context.state.minimaleEisenPerDossier;
		minimaleEisen.prioritairGebruikTopsportfederaties.push({ id: GenerateGuid(), minimaleEisenAlgemeen: minimaleEisen.id, topsportfederatie: null, aantalUrenPerWeekVoorPrestatieprogramma: null, aantalUrenPerWeekVoorOntwikkelingsrogramma: null });
		return this.context.setState({
			minimaleEisenPerDossier: minimaleEisen,
			hasUnsavedChanges: true
		});
	}

	onTopsportfederatieRemove(i) {
		const minimaleEisen = this.context.state.minimaleEisenPerDossier;
		minimaleEisen.prioritairGebruikTopsportfederaties.splice(i, 1);

		return this.context.setState({
			minimaleEisenPerDossier: minimaleEisen,
			hasUnsavedChanges: true
		});
	}

	onDropFiles(component, files) {
		this.handleFileRequest(component, files, () => { files.forEach(file => uploadOneFile(this.context, this.context.props.uploadDocument, this.context.props.dossierId, domainConstants.DocumentTab.MinimaleEisen, component, file)); });
	}

	onDeleteFile(component, fileName) {
		this.handleFileRequest(component, fileName, () => { deleteOneFile(this.context, this.context.props.deleteDocument, this.context.props.dossierId, domainConstants.DocumentTab.MinimaleEisen, component, fileName); });
	}

	handleFileRequest(component, actionParam, fileProcess) {
		if (!this.context.state.fileSessionStarted) {
			this.context.props.startFileSession(this.context.props.dossierId, domainConstants.DocumentTab.MinimaleEisen)
				.then(result => {
					if (!result.success) {
						showToastrError("Verwerken van bestand is mislukt");
						throw new Error("File process failed"); //Stops promise
					} else {
						this.context.setState({
							fileSessionStarted: true,
							hasUnsavedChanges: true
						});
					}
				}).then(() => fileProcess(component, actionParam));
		}
		else
			fileProcess(component, actionParam);
	}

	onSave(event) {
		event.preventDefault();

		if (this.context.state.fileSessionStarted) {
			showToastrInfo("Verwerken van bestanden. Even geduld");

			this.context.props.endFileSession(this.context.props.dossierId, domainConstants.DocumentTab.MinimaleEisen)
				.then(result => {
					if (!result.success) {
						showToastrError(domainConstants.HAS_FILE_EXCEPTION);
						throw new Error("File process failed"); //Stops promise
					} else {
						this.context.setState({ fileSessionStarted: false });
						showToastrSuccess("Verwerken van bestanden gelukt");
					}

				});
		}

		this.context.props.saveMinimaleEisenPerDossier(this.context.state.minimaleEisenPerDossier, this.context.state.documenten)
			.then((notification) => {
				let isSaved = showToastr(notification);
				if (isSaved) {
					this.context.setState({ hasUnsavedChanges: false });
					//reload latest infrastructuren in case of update to InitialisatieOK property of an infrastructuur
					this.context.props.loadInfrastructurenByDossierId(this.context.props.dossierId);
				}
			});
	}
}